module.exports = __webpack_public_path__ + "img/loginBg.cea54af3.jpg";